module.exports = __webpack_public_path__ + "img/tours_6.9f34e0a3.jpg";